import { ListItemIcon, MenuItem } from '@mui/material';
import { DriveContentType, IDriveContent } from 'src/@types/drive';
import Iconify from 'src/components/iconify';
import { useDriveContentQuery } from 'src/hooks/useDriveContentQuery';
import {
  ExplorerMenuItem,
  StyledListItemText,
} from '../shared/ExplorerMenuItem';
import { DriveExplorerLabel } from './DriveExplorerLabel';
import { isValidFile } from './utils';

type Props = {
  driveItem: IDriveContent;
  selectFile: (file: IDriveContent) => void;
  isSelected: (file: IDriveContent) => boolean;
  validMimeTypes: string[];
};

export const DriveExplorerItem = ({
  driveItem,
  selectFile,
  isSelected,
  validMimeTypes,
}: Props) => {
  const { driveContents, isDriveContentLoading } = useDriveContentQuery(
    driveItem._id,
  );

  const selected = isSelected(driveItem);

  const disabled =
    (driveItem.type === DriveContentType.FOLDER && !driveItem.totalFiles) ||
    (driveItem.type === DriveContentType.FILE &&
      !isValidFile(driveItem.mimeType, validMimeTypes));

  return (
    <>
      <ExplorerMenuItem
        hasChildren={!!driveItem.totalFiles}
        selected={selected}
        disabled={disabled}
        onClick={() => selectFile(driveItem)}
        isSelectable={driveItem.type === DriveContentType.FILE}
        labelChild={<DriveExplorerLabel driveItem={driveItem} />}
        childrenChild={
          <>
            {isDriveContentLoading ? (
              <MenuItem>
                <ListItemIcon>
                  <Iconify icon="eos-icons:loading" />
                </ListItemIcon>
                <StyledListItemText color="text.secondary">
                  Loading
                </StyledListItemText>
              </MenuItem>
            ) : (
              driveContents?.map((item) => (
                <DriveExplorerItem
                  key={item._id}
                  driveItem={item}
                  selectFile={selectFile}
                  isSelected={isSelected}
                  validMimeTypes={validMimeTypes}
                />
              ))
            )}
          </>
        }
      />
    </>
  );
};
